// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__86Aws","button__disabled":"Button_button__disabled__wVueP","button__fullWidth":"Button_button__fullWidth__TIOOx"};